export default __webpack_public_path__ + "static/media/no.b58407ff.jpg";